export enum VisucloudRoles {
    ZeissBackofficeAdministrator,
    ZeissServiceStaffGlobal,
    ZeissServiceStaffRegional,
    ECPManager,
    ECPStaff,
    RealmManager,
    CentrationOperator
}
